import { all, takeLatest, put, call } from 'redux-saga/effects';
import { request } from '../../utils/http';

import { getSimplifiedError } from '../../utils/error';
import {
  INVITES_LIST_REQUEST,
  INVITES_LIST_SUCCESS,
  INVITES_LIST_ERROR,
  INVITE_REQUEST,
  INVITE_SUCCESS,
  INVITE_ERROR,
  RESEND_INVITE_REQUEST,
  RESEND_INVITE_SUCCESS,
  RESEND_INVITE_ERROR,
  VALIDATE_REQUEST,
  VALIDATE_ERROR,
  VALIDATE_SUCCESS,
  ACCEPT_INVITE_REQUEST,
  ACCEPT_INVITE_SUCCESS,
  ACCEPT_INVITE_ERROR,
  FEEDBACK_REQUEST,
  FEEDBACK_SUCCESS,
  FEEDBACK_ERROR,
  ALL_USERS_REQUEST,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_ERROR,
  ALL_USERS_SUCCESS,
  ALL_USERS_ERROR,
} from '../reducers/ManagerReducer';
import { LOGIN_REQUEST } from '../reducers/AuthReducer';

function getInvites() {
  return request.get('/invitation/list/');
}

function* handleGetInvites() {
  try {
    const { data } = yield call(getInvites);
    yield put({
      type: INVITES_LIST_SUCCESS,
      inviteList: data,
    });
  } catch (error) {
    yield put({
      type: INVITES_LIST_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function inviteEmployee(payload) {
  return request.post('/invitation/', payload);
}

function* handleInviteEmployee({ payload }) {
  try {
    yield call(inviteEmployee, payload);
    yield put({
      type: INVITE_SUCCESS,
      data: payload,
    });
  } catch (error) {
    yield put({
      type: INVITE_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function resendInvite(payload) {
  return request.post('/invitation/resend/', payload);
}

function* handleResendInvite({ payload }) {
  try {
    yield call(resendInvite, payload);
    yield put({
      type: RESEND_INVITE_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: RESEND_INVITE_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function validateInvite(payload) {
  return request.post('/invitation/validate/', payload);
}

function* handleInviteValidate({ payload }) {
  try {
    const { data } = yield call(validateInvite, payload);
    yield put({
      type: VALIDATE_SUCCESS,
      userInfo: data,
    });
  } catch (error) {
    yield put({
      type: VALIDATE_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function acceptInvite(payload) {
  return request.post('/invitation/accept/', payload);
}

function* handleAcceptInvite({ payload }) {
  const { email, password } = payload;
  try {
    yield call(acceptInvite, payload);

    yield put({
      type: LOGIN_REQUEST,
      payload: {
        email,
        password,
      },
    });

    yield put({
      type: ACCEPT_INVITE_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: ACCEPT_INVITE_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function sendFeedback(payload) {
  return request.post('/feedback/', payload);
}

function* handleFeedback({ payload }) {
  try {
    yield call(sendFeedback, payload);

    yield put({
      type: FEEDBACK_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: FEEDBACK_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function getAllUsers() {
  return request.get('/team/');
}

function* handleGetAllUsers() {
  try {
    const { data } = yield call(getAllUsers);
    yield put({
      type: ALL_USERS_SUCCESS,
      list: data,
    });
  } catch (error) {
    yield put({
      type: ALL_USERS_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function getUserDetails(id) {
  return request.get(`/team/${id}/`);
}

function* handleGetUserDetails({ payload }) {
  try {
    const { data } = yield call(getUserDetails, payload);

    yield put({
      type: USER_DETAILS_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({
      type: USER_DETAILS_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

export default all([
  takeLatest(INVITES_LIST_REQUEST, handleGetInvites),
  takeLatest(INVITE_REQUEST, handleInviteEmployee),
  takeLatest(RESEND_INVITE_REQUEST, handleResendInvite),
  takeLatest(VALIDATE_REQUEST, handleInviteValidate),
  takeLatest(ACCEPT_INVITE_REQUEST, handleAcceptInvite),
  takeLatest(FEEDBACK_REQUEST, handleFeedback),
  takeLatest(ALL_USERS_REQUEST, handleGetAllUsers),
  takeLatest(USER_DETAILS_REQUEST, handleGetUserDetails),
]);
